module.exports = __webpack_public_path__ + "cfa4f6f31e023bfe805f39719eaac327.png";